'use client';

import { Box, Button, Container, HStack, Icon, Stack, Text } from '@chakra-ui/react';
import { LuCookie } from 'react-icons/lu';
import { useTranslation } from 'react-i18next';
import { useAnalytics } from '@/contexts/AnalyticsContext';

const CookieConsent = () => {
  const { consent, setConsent } = useAnalytics();
  const { t } = useTranslation('common');

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'true');
    setConsent(true);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'false');
    setConsent(false);
  };

  if (consent !== null) return null; // Hide if user already made a choice

  return (
    <>
      {/* Cookie Consent Banner */}
      <Box
        position='fixed'
        bottom='0'
        zIndex={1400}
        width='100%'
        bg='bg-banner'
        color='white'
        data-state='open'
        _open={{
          animationName: 'slide-from-bottom-full',
          animationDuration: '1000ms'
        }}
        _closed={{
          animationName: 'fade-out',
          animationDuration: '300ms'
        }}
      >
        <Container py={{ base: '4', md: '3.5' }}>
          <Stack
            gap='4'
            justifyContent={{ base: 'start', md: 'space-between' }}
            flexDirection={{ base: 'column', md: 'row' }}
          >
            <Stack
              direction={{ base: 'column', md: 'row' }}
              alignItems={{ base: 'start', md: 'center' }}
              gap={{ base: '1', md: '2' }}
            >
              <HStack gap='2'>
                <Icon as={LuCookie} boxSize={6} />
                <Text fontWeight='medium' display={{ md: 'none' }}>
                  {t('cookie.title')}
                </Text>
              </HStack>
              <Text color='gray.300'>{t('cookie.description')}</Text>
            </Stack>
            <HStack gap='3'>
              <Button
                variant='outline'
                colorPalette='secondary'
                color='gray.200'
                borderColor='gray.200'
                _hover={{ bg: 'secondary.400' }}
                onClick={handleDecline}
              >
                {t('cookie.reject')}
              </Button>
              <Button
                colorPalette='brand'
                color='white'
                bg='brand.700'
                _hover={{ bg: 'brand.800' }}
                onClick={handleAccept}
              >
                {t('cookie.allow')}
              </Button>
            </HStack>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default CookieConsent;
